export let subItemProps = {
    key: 0,
    id: 0,
    sub_category_name: '',
    piece_rate: 0,
    trial_type_price_list: [],
    trial_finish_rate: 0,
    production_buffer_days: 0
}

export let qualityItemProps = {
    key: 0,
    id: 0,
    quality_point: ''
}

export let dataProps = {
    id: 0,
    category_name: '', 
    piece_rate: 0,
    type: 0,  
    production_buffer_days: 0,
    sub_item_list: [JSON.parse(JSON.stringify(subItemProps))],
    deleted_sub_item_list_items: [],
    trial_type_price_list: [],
    trial_finish_rate: 0,

    quality_point_list: [JSON.parse(JSON.stringify(qualityItemProps))],
    deleted_quality_point_list_items: []
}


// WEBPACK FOOTER //
// ./src/store/modules/itemCategory/properties.js